/**
 * What the coach may recommend in a lesson, by what the lesson is: after a
 * Free Intro Call, a Live Video Lesson, Monthly Coaching or a Training
 * Program (decision 48); after a single
 * Live Video Lesson, Monthly Coaching; in a Monthly Coaching lesson,
 * nothing, so there is no Recommend button. Pure, so it is unit tested.
 */

export type RecommendOfferKey = 'single' | 'membership' | 'program';

/** The offers as the room names them. Never "Membership" or "Single Lesson" (local/live-offer-names). */
export const OFFER_TITLE: Record<RecommendOfferKey, string> = {
  single: 'Live Video Lesson',
  membership: 'Monthly Coaching',
  program: 'Training Program',
};

export function recommendOffers(
  b: { offeringType: string; membershipId?: string | null },
  /** The player already has Monthly Coaching with this coach: it is not offered again. */
  held: { member?: boolean } = {},
): RecommendOfferKey[] {
  if (b.membershipId || b.offeringType === 'live_membership') return [];
  const offers: RecommendOfferKey[] = b.offeringType === 'free_intro_call' ? ['single', 'membership', 'program'] : ['membership'];
  return held.member ? offers.filter((o) => o !== 'membership') : offers;
}
